// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* === LEFT BAR MAIN === */
.left-bar-kds {
  display: flex;
  min-height: 0;
  flex-direction: column;
  overflow: hidden;
  border-radius: 16px; /* rounded-2xl */
  border: 1px solid rgba(251, 191, 36, 0.3); /* border-amber-200/70: amber-200 is rgb(253, 230, 138) / #fde68a */
  background: #ffffff; /* bg-white */
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05); /* shadow-sm */
  zoom: 1;
}

/* === HEADER === */
.leftbar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px; /* gap-3 */
  border-bottom: 1px solid #fef3c7; /* border-amber-100 */
  background-color: rgba(254, 252, 232, 0.8); /* bg-amber-50/80 */
  padding: 12px 16px; /* px-4 py-3 */
}

.leftbar-header-left {
  display: flex;
  align-items: center;
  gap: 8px; /* gap-2 */
}

.leftbar-dot {
  width: 10px; /* h-2.5 */
  height: 10px; /* w-2.5 */
  border-radius: 9999px; /* rounded-full */
  background-color: #f59e0b; /* bg-amber-500 */
}

.leftbar-title {
  font-size: 1em; /* text-sm - relative to parent for font scaling */
  font-weight: 700; /* font-bold */
  text-transform: uppercase; /* uppercase */
  letter-spacing: 0.05em; /* tracking-wider */
  color: #1e293b; /* text-slate-800 */
  margin: 0;
  line-height: 1;
}

.leftbar-count {
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  padding: 2px 10px;
  font-size: 0.857em;
  font-weight: 600;
  background-color: #ffffff;
  color: #b45309;
  border: 1px solid #fef3c7;
  transition: colors 0.15s ease-in-out;
}

/* === ACCEPT ALL BUTTON === */
.accept-all-btn {
  display: inline-flex;
  height: 32px;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  border: 1px solid #e2e8f0;
  background-color: #ffffff;
  padding: 0 12px;
  font-size: 0.857em;
  font-weight: 600;
  color: #334155;
  cursor: pointer;
  transition:
    background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out;
}

.accept-all-btn:hover:not(:disabled) {
  background-color: #f8fafc; /* hover:bg-slate-50 */
}

.accept-all-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* === ORDERS CONTAINER (Scrollable) === */
.orders-container {
  display: flex;
  flex-direction: column;
  padding: 12px; /* px-3 py-3 */
  gap: 12px; /* space-y-3 */
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1;
}

/* Scrollbar styling */
.orders-container::-webkit-scrollbar {
  width: 8px;
}

.orders-container::-webkit-scrollbar-thumb {
  background-color: #cbd5e1; /* slate-300 */
  border-radius: 9999px;
}

.orders-container::-webkit-scrollbar-thumb:hover {
  background-color: #94a3b8; /* slate-400 */
}

.orders-container::-webkit-scrollbar-track {
  background: #f8fafc; /* slate-50 */
}

/* === ORDER CARD === */
.order-card {
  position: relative;
  border-radius: calc(1rem + 4px);
  border: 1px solid #fde68a;
  padding: 12px;
  display: flex;
  flex-direction: column;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.order-card:hover {
  transform: translateY(-2px); /* hover:-translate-y-0.5 */
  box-shadow: 0 12px 30px rgba(245, 158, 11, 0.18) !important;
}

/* Background Gradients */
.white-card {
  background: linear-gradient(
    135deg,
    #fffbeb,
    #ffffff,
    #ffffff
  ); /* bg-gradient-to-br from-amber-50 via-white to-white */
  box-shadow: 0 10px 24px rgba(245, 158, 11, 0.12);
}

/* Blinking animation for new orders */
.blink-card {
  box-shadow: 0 10px 24px rgba(245, 158, 11, 0.12);
  animation: whiteBlink 1.4s ease-in-out infinite;
}

@keyframes whiteBlink {
  0%,
  100% {
    background: linear-gradient(135deg, #fffbeb, #ffffff, #ffffff);
    box-shadow: 0 10px 24px rgba(245, 158, 11, 0.12);
    border-color: #fde68a;
  }
  50% {
    background: linear-gradient(135deg, #ffe5be, #fffbeb, #ffffff);
    box-shadow: 0 12px 30px rgba(245, 158, 11, 0.3);
    border-color: #f59e0b;
  }
}

/* === HEADER INSIDE CARD === */
.order-header-flex {
  display: flex;
  align-items: start;
  justify-content: space-between;
  gap: 8px; /* gap-2 */
}

.order-header-left {
  display: flex;
  flex-direction: column;
}

.order-token {
  margin: 0;
  font-size: 1.143em; /* text-base - relative for font scaling */
  font-weight: 700; /* font-bold */
  letter-spacing: -0.025em; /* tracking-tight */
  color: #0f172a; /* text-slate-900 */
  line-height: 1.25;
}

.platform-tag {
  margin-top: 4px; /* mt-1 */
  display: flex;
  align-items: center;
  gap: 8px; /* gap-2 */
}

.platform-badge {
  display: flex;
  align-items: center;
  gap: 8px; /* gap-2 */
  font-size: 0.786em; /* text-[11px] - relative for font scaling */
  color: #64748b; /* text-slate-500 */
  font-weight: 500; /* font-medium */
}

.platform-icon {
  width: 24px; /* w-6 */
  height: 24px; /* h-6 */
  object-fit: contain;
  border-radius: 6px; /* rounded-md */
}

.platform-badge.other {
  background-color: #f1f5f9;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 0.786em;
}

/* Card Header Right Side */
.order-header-right {
  text-align: right;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.order-time {
  margin: 0;
  font-size: 0.857em; /* text-xs - relative for font scaling */
  font-weight: 600; /* font-semibold */
  color: #94a3b8; /* text-slate-400 */
  line-height: 1.25;
}

.kds-itemtag-div {
  margin-top: 4px; /* mt-1 */
  display: flex;
  align-items: center;
  gap: 8px;
}

.item-count {
  margin: 0;
  font-size: 0.786em; /* text-[11px] - relative for font scaling */
  color: #64748b; /* text-slate-500 */
  font-weight: 500;
  line-height: 1.25;
}

.chevron-icon-clickable {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  border-radius: 6px;
  transition: background-color 0.15s ease-in-out;
}

.chevron-icon-clickable:hover {
  background-color: #f1f5f9;
}

.kds-chevronRightIcon-item-tag {
  width: 14px;
  height: 14px;
  color: #94a3b8;
}

/* === ITEMS PREVIEW === */
.order-items-preview {
  margin-top: 12px;
  border-radius: calc(1rem + 4px);
  border: 1px solid #fef3c7;
  background-color: rgba(255, 255, 255, 0.8);
  padding: 8px 12px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.7);
}

.order-items-space {
  display: flex;
  flex-direction: column;
  gap: 6px; /* space-y-1.5 */
}

.order-item-preview-row {
  display: flex;
  align-items: start;
  justify-content: space-between;
  gap: 8px; /* gap-2 */
  font-size: 0.786em; /* text-[11px] - relative for font scaling */
}

.order-item-preview-name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis; /* truncate */
  white-space: nowrap;
  font-weight: 500; /* font-medium */
  color: #334155; /* text-slate-700 */
}

.order-item-preview-qty {
  flex-shrink: 0; /* shrink-0 */
  border-radius: 9999px; /* rounded-full */
  background-color: #fffbeb; /* bg-amber-50 */
  padding: 2px 8px; /* px-2 py-0.5 */
  font-weight: 600; /* font-semibold */
  color: #b45309; /* text-amber-700 */
  line-height: 1;
}

/* === FOOTER BUTTONS === */
.order-footer {
  margin-top: 16px; /* mt-4 */
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr)); /* grid-cols-2 */
  gap: 8px; /* gap-2 */
}

.reject-btn-left-bar {
  display: inline-flex;
  height: 40px;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  border: 1px solid #e2e8f0;
  background-color: #ffffff;
  color: #334155;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
  padding: 0;
}

.reject-btn-left-bar:hover:not(:disabled) {
  background-color: #f8fafc; /* hover:bg-slate-50 */
}

.accept-btn-left-bar {
  display: inline-flex;
  height: 40px;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  background-color: #020617;
  color: #ffffff;
  cursor: pointer;
  border: none;
  transition: all 0.15s ease-in-out;
  padding: 0;
}

.accept-btn-left-bar:hover:not(:disabled) {
  background-color: #1e293b; /* hover:bg-slate-800 */
}

.reject-btn-left-bar:disabled,
.accept-btn-left-bar:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-icon {
  width: 16px !important;
  height: 16px !important;
}

/* === SPINNERS === */
.spinner {
  border: 2px solid rgba(0, 0, 0, 0.15);
  border-top: 2px solid #0f172a;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  animation: spin 0.6s linear infinite;
}

.spinner.small {
  width: 14px;
  height: 14px;
}

.spinner.white {
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-top: 2px solid #ffffff;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* === NO ORDERS VIEW === */
.no-orders-parent-container {
  display: flex;
  height: 160px; /* h-40 */
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 12px; /* rounded-xl */
  border: 1px dashed #fde68a; /* border border-dashed border-amber-200 */
  background-color: rgba(255, 251, 235, 0.4); /* bg-amber-50/40 */
  text-align: center;
  color: #94a3b8; /* text-slate-400 */
}

.no-orders-icon {
  margin-bottom: 12px; /* mb-3 */
  height: 32px; /* h-8 */
  width: 32px; /* w-8 */
  opacity: 0.3; /* opacity-30 */
}

.no-orders {
  font-size: 1em; /* text-sm - relative for font scaling */
  font-weight: 500; /* font-medium */
  margin: 0;
}

/* === LOADING MORE === */
.loading-more {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px;
  color: #64748b;
  font-size: 0.929em;
  font-weight: 500;
}

/* Pending cards stack in their own vertically scrollable queue. */
.left-bar-kds {
  min-width: 0;
  min-height: 0;
}

.leftbar-header {
  flex-shrink: 0;
}

.orders-container {
  flex-direction: column;
  align-items: stretch;
  min-width: 0;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior-y: contain;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  scrollbar-color: #d6c4a2 #fff9ed;
}

.orders-container::-webkit-scrollbar {
  width: 8px;
  height: auto;
}

.orders-container::-webkit-scrollbar-thumb {
  border: 2px solid #fff9ed;
  border-radius: 10px;
}

.orders-container > .kds-pending-card {
  flex: 0 0 auto;
  width: 100%;
  box-sizing: border-box;
  min-width: 0;
  height: auto;
  min-height: 0;
  max-height: none;
  overflow: visible;
}

.orders-container > .kds-pending-card .order-items-preview {
  flex: 0 0 auto;
  min-height: 0;
  height: auto;
  max-height: none;
  overflow: visible;
}

.orders-container > .kds-pending-card .order-items-space,
.orders-container > .kds-pending-card .order-item-preview-row {
  min-width: 0;
}

.orders-container > .kds-pending-card .order-item-preview-name {
  overflow: visible;
  overflow-wrap: anywhere;
  text-overflow: clip;
  white-space: normal;
}

.orders-container > .kds-pending-card .order-item-preview-row {
  align-items: flex-start;
}

.orders-container > .kds-pending-card .order-item-preview-wrap > .kds-item-preparation {
  margin: 3px 0 0;
  padding: 4px 6px;
  font-size: calc(9px + var(--kds-font-delta, 0px));
}

.orders-container > .kds-pending-card .order-item-preview-wrap > .kds-item-preparation .kds-prep-summary {
  gap: 3px 8px;
}

.orders-container > .no-orders-parent-container,
.orders-container > .loading-more {
  flex: 0 0 auto;
  width: 100%;
}

.orders-container:focus-visible {
  outline: 2px solid #ad5b20;
  outline-offset: -2px;
}

.dark .orders-container {
  scrollbar-color: #776548 #302c25;
}

@media (max-width: 700px) {
  .left-bar-kds {
    flex: 0 0 min(34%, 250px);
    width: 100%;
  }

  .orders-container > .kds-pending-card {
    flex-basis: auto;
    width: 100%;
  }
}

/* Orders-view disclosure rail. The header remains present in every queue state. */
.left-bar-kds {
  /* Fixed basis so long item names wrap instead of widening the column. */
  flex: 0 0 clamp(280px, 26vw, 380px);
  width: auto;
  min-width: 0;
  transition: flex-basis 180ms ease;
}

.leftbar-header {
  min-height: 54px;
}

.leftbar-content {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
}

.leftbar-content[hidden] {
  display: none !important;
}

.pending-order-numbers {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 7px;
  min-height: 0;
  margin: 0;
  padding: 8px 5px;
  overflow-y: auto;
  overflow-x: hidden;
  list-style: none;
}

.pending-order-number,
.pending-number-state {
  flex: 0 0 auto;
  padding: 7px 2px;
  border: 1px solid #eadbbd;
  border-radius: 7px;
  background: #fff;
  color: #493c24;
  font-size: calc(12px + var(--kds-font-delta, 0px));
  font-weight: 750;
  text-align: center;
  font-variant-numeric: tabular-nums;
  overflow-wrap: anywhere;
}

.dark .pending-order-number,
.dark .pending-number-state {
  border-color: #625541;
  background: #302d27;
  color: #e8c58a;
}

.leftbar-content > .accept-all-btn {
  align-self: flex-end;
  flex: 0 0 auto;
  margin: 8px 12px 0;
}

.leftbar-content > .orders-container {
  flex: 1 1 0;
  min-width: 0;
}

.pending-collapse-toggle {
  display: inline-flex;
  flex: 0 0 34px;
  width: 34px;
  height: 34px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 1px solid #e8d7b6;
  border-radius: 9px;
  background: #fffdf7;
  color: #79562e;
  cursor: pointer;
}

.pending-collapse-toggle svg {
  display: block;
  width: 17px;
  height: 17px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}

.pending-collapse-toggle:hover {
  background: #fff5df;
}

.pending-collapse-toggle:focus-visible {
  outline: 2px solid #ad5b20;
  outline-offset: 2px;
}

.left-bar-kds.is-collapsed {
  flex-basis: 66px;
}

.left-bar-kds.is-collapsed .leftbar-header {
  flex: 0 0 auto;
  flex-direction: column;
  justify-content: flex-start;
  gap: 12px;
  padding: 12px 8px;
}

.left-bar-kds.is-collapsed .leftbar-header-left {
  flex-direction: column;
  gap: 7px;
}

.left-bar-kds.is-collapsed .leftbar-title {
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  font-size: calc(11px + var(--kds-font-delta, 0px));
  letter-spacing: .08em;
}

.left-bar-kds.is-collapsed .leftbar-count {
  padding: 2px 6px;
}

.left-bar-kds.is-collapsed .pending-collapse-toggle {
  flex-basis: 32px;
  width: 32px;
  height: 32px;
}

.dark .pending-collapse-toggle {
  border-color: #625541;
  background: #302d27;
  color: #e8c58a;
}

.dark .pending-collapse-toggle:hover {
  background: #40392d;
}

@media (max-width: 700px) {
  .left-bar-kds {
    flex: 0 0 min(38vw, 280px);
    width: min(38vw, 280px);
  }

  .left-bar-kds.is-collapsed {
    flex: 0 0 58px;
    width: 58px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .left-bar-kds {
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/KDS/components/LeftBar/leftbarkds.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB,EAAE,gBAAgB;EACrC,yCAAyC,EAAE,mEAAmE;EAC9G,mBAAmB,EAAE,aAAa;EAClC,yCAAyC,EAAE,cAAc;EACzD,OAAO;AACT;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS,EAAE,UAAU;EACrB,gCAAgC,EAAE,qBAAqB;EACvD,0CAA0C,EAAE,mBAAmB;EAC/D,kBAAkB,EAAE,cAAc;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ,EAAE,UAAU;AACtB;;AAEA;EACE,WAAW,EAAE,UAAU;EACvB,YAAY,EAAE,UAAU;EACxB,qBAAqB,EAAE,iBAAiB;EACxC,yBAAyB,EAAE,iBAAiB;AAC9C;;AAEA;EACE,cAAc,EAAE,kDAAkD;EAClE,gBAAgB,EAAE,cAAc;EAChC,yBAAyB,EAAE,cAAc;EACzC,sBAAsB,EAAE,mBAAmB;EAC3C,cAAc,EAAE,mBAAmB;EACnC,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA,8BAA8B;AAC9B;EACE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf;;kCAEgC;AAClC;;AAEA;EACE,yBAAyB,EAAE,sBAAsB;AACnD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa,EAAE,cAAc;EAC7B,SAAS,EAAE,cAAc;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,OAAO;AACT;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB,EAAE,cAAc;EACzC,qBAAqB;AACvB;;AAEA;EACE,yBAAyB,EAAE,cAAc;AAC3C;;AAEA;EACE,mBAAmB,EAAE,aAAa;AACpC;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,kDAAkD;AACpD;;AAEA;EACE,2BAA2B,EAAE,2BAA2B;EACxD,2DAA2D;AAC7D;;AAEA,yBAAyB;AACzB;EACE;;;;;GAKC,EAAE,uDAAuD;EAC1D,gDAAgD;AAClD;;AAEA,sCAAsC;AACtC;EACE,gDAAgD;EAChD,+CAA+C;AACjD;;AAEA;EACE;;IAEE,8DAA8D;IAC9D,gDAAgD;IAChD,qBAAqB;EACvB;EACA;IACE,8DAA8D;IAC9D,+CAA+C;IAC/C,qBAAqB;EACvB;AACF;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,QAAQ,EAAE,UAAU;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,kBAAkB,EAAE,0CAA0C;EAC9D,gBAAgB,EAAE,cAAc;EAChC,wBAAwB,EAAE,mBAAmB;EAC7C,cAAc,EAAE,mBAAmB;EACnC,iBAAiB;AACnB;;AAEA;EACE,eAAe,EAAE,SAAS;EAC1B,aAAa;EACb,mBAAmB;EACnB,QAAQ,EAAE,UAAU;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ,EAAE,UAAU;EACpB,kBAAkB,EAAE,4CAA4C;EAChE,cAAc,EAAE,mBAAmB;EACnC,gBAAgB,EAAE,gBAAgB;AACpC;;AAEA;EACE,WAAW,EAAE,QAAQ;EACrB,YAAY,EAAE,QAAQ;EACtB,mBAAmB;EACnB,kBAAkB,EAAE,eAAe;AACrC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,kBAAkB,EAAE,wCAAwC;EAC5D,gBAAgB,EAAE,kBAAkB;EACpC,cAAc,EAAE,mBAAmB;EACnC,iBAAiB;AACnB;;AAEA;EACE,eAAe,EAAE,SAAS;EAC1B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,kBAAkB,EAAE,4CAA4C;EAChE,cAAc,EAAE,mBAAmB;EACnC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,yBAAyB;EACzB,0CAA0C;EAC1C,iBAAiB;EACjB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ,EAAE,gBAAgB;AAC5B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,QAAQ,EAAE,UAAU;EACpB,kBAAkB,EAAE,4CAA4C;AAClE;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB,EAAE,aAAa;EACtC,mBAAmB;EACnB,gBAAgB,EAAE,gBAAgB;EAClC,cAAc,EAAE,mBAAmB;AACrC;;AAEA;EACE,cAAc,EAAE,aAAa;EAC7B,qBAAqB,EAAE,iBAAiB;EACxC,yBAAyB,EAAE,gBAAgB;EAC3C,gBAAgB,EAAE,gBAAgB;EAClC,gBAAgB,EAAE,kBAAkB;EACpC,cAAc,EAAE,mBAAmB;EACnC,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB,EAAE,SAAS;EAC3B,aAAa;EACb,gDAAgD,EAAE,gBAAgB;EAClE,QAAQ,EAAE,UAAU;AACtB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,UAAU;AACZ;;AAEA;EACE,yBAAyB,EAAE,sBAAsB;AACnD;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,iCAAiC;EACjC,UAAU;AACZ;;AAEA;EACE,yBAAyB,EAAE,uBAAuB;AACpD;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,qBAAqB;AACrB;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,6BAA6B;AAC/B;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,aAAa,EAAE,SAAS;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB,EAAE,eAAe;EACpC,0BAA0B,EAAE,0CAA0C;EACtE,0CAA0C,EAAE,mBAAmB;EAC/D,kBAAkB;EAClB,cAAc,EAAE,mBAAmB;AACrC;;AAEA;EACE,mBAAmB,EAAE,SAAS;EAC9B,YAAY,EAAE,QAAQ;EACtB,WAAW,EAAE,QAAQ;EACrB,YAAY,EAAE,eAAe;AAC/B;;AAEA;EACE,cAAc,EAAE,wCAAwC;EACxD,gBAAgB,EAAE,gBAAgB;EAClC,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,kEAAkE;AAClE;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,iCAAiC;EACjC,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;AACF;;AAEA,kFAAkF;AAClF;EACE,wEAAwE;EACxE,mCAAmC;EACnC,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kDAAkD;EAClD,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,2BAA2B;EAC3B,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kDAAkD;EAClD,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;IAC1B,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,WAAW;EACb;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* === LEFT BAR MAIN === */\n.left-bar-kds {\n  display: flex;\n  min-height: 0;\n  flex-direction: column;\n  overflow: hidden;\n  border-radius: 16px; /* rounded-2xl */\n  border: 1px solid rgba(251, 191, 36, 0.3); /* border-amber-200/70: amber-200 is rgb(253, 230, 138) / #fde68a */\n  background: #ffffff; /* bg-white */\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05); /* shadow-sm */\n  zoom: 1;\n}\n\n/* === HEADER === */\n.leftbar-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px; /* gap-3 */\n  border-bottom: 1px solid #fef3c7; /* border-amber-100 */\n  background-color: rgba(254, 252, 232, 0.8); /* bg-amber-50/80 */\n  padding: 12px 16px; /* px-4 py-3 */\n}\n\n.leftbar-header-left {\n  display: flex;\n  align-items: center;\n  gap: 8px; /* gap-2 */\n}\n\n.leftbar-dot {\n  width: 10px; /* h-2.5 */\n  height: 10px; /* w-2.5 */\n  border-radius: 9999px; /* rounded-full */\n  background-color: #f59e0b; /* bg-amber-500 */\n}\n\n.leftbar-title {\n  font-size: 1em; /* text-sm - relative to parent for font scaling */\n  font-weight: 700; /* font-bold */\n  text-transform: uppercase; /* uppercase */\n  letter-spacing: 0.05em; /* tracking-wider */\n  color: #1e293b; /* text-slate-800 */\n  margin: 0;\n  line-height: 1;\n}\n\n.leftbar-count {\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50px;\n  padding: 2px 10px;\n  font-size: 0.857em;\n  font-weight: 600;\n  background-color: #ffffff;\n  color: #b45309;\n  border: 1px solid #fef3c7;\n  transition: colors 0.15s ease-in-out;\n}\n\n/* === ACCEPT ALL BUTTON === */\n.accept-all-btn {\n  display: inline-flex;\n  height: 32px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50px;\n  border: 1px solid #e2e8f0;\n  background-color: #ffffff;\n  padding: 0 12px;\n  font-size: 0.857em;\n  font-weight: 600;\n  color: #334155;\n  cursor: pointer;\n  transition:\n    background-color 0.15s ease-in-out,\n    border-color 0.15s ease-in-out;\n}\n\n.accept-all-btn:hover:not(:disabled) {\n  background-color: #f8fafc; /* hover:bg-slate-50 */\n}\n\n.accept-all-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* === ORDERS CONTAINER (Scrollable) === */\n.orders-container {\n  display: flex;\n  flex-direction: column;\n  padding: 12px; /* px-3 py-3 */\n  gap: 12px; /* space-y-3 */\n  overflow-y: auto;\n  overflow-x: hidden;\n  flex: 1;\n}\n\n/* Scrollbar styling */\n.orders-container::-webkit-scrollbar {\n  width: 8px;\n}\n\n.orders-container::-webkit-scrollbar-thumb {\n  background-color: #cbd5e1; /* slate-300 */\n  border-radius: 9999px;\n}\n\n.orders-container::-webkit-scrollbar-thumb:hover {\n  background-color: #94a3b8; /* slate-400 */\n}\n\n.orders-container::-webkit-scrollbar-track {\n  background: #f8fafc; /* slate-50 */\n}\n\n/* === ORDER CARD === */\n.order-card {\n  position: relative;\n  border-radius: calc(1rem + 4px);\n  border: 1px solid #fde68a;\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.order-card:hover {\n  transform: translateY(-2px); /* hover:-translate-y-0.5 */\n  box-shadow: 0 12px 30px rgba(245, 158, 11, 0.18) !important;\n}\n\n/* Background Gradients */\n.white-card {\n  background: linear-gradient(\n    135deg,\n    #fffbeb,\n    #ffffff,\n    #ffffff\n  ); /* bg-gradient-to-br from-amber-50 via-white to-white */\n  box-shadow: 0 10px 24px rgba(245, 158, 11, 0.12);\n}\n\n/* Blinking animation for new orders */\n.blink-card {\n  box-shadow: 0 10px 24px rgba(245, 158, 11, 0.12);\n  animation: whiteBlink 1.4s ease-in-out infinite;\n}\n\n@keyframes whiteBlink {\n  0%,\n  100% {\n    background: linear-gradient(135deg, #fffbeb, #ffffff, #ffffff);\n    box-shadow: 0 10px 24px rgba(245, 158, 11, 0.12);\n    border-color: #fde68a;\n  }\n  50% {\n    background: linear-gradient(135deg, #ffe5be, #fffbeb, #ffffff);\n    box-shadow: 0 12px 30px rgba(245, 158, 11, 0.3);\n    border-color: #f59e0b;\n  }\n}\n\n/* === HEADER INSIDE CARD === */\n.order-header-flex {\n  display: flex;\n  align-items: start;\n  justify-content: space-between;\n  gap: 8px; /* gap-2 */\n}\n\n.order-header-left {\n  display: flex;\n  flex-direction: column;\n}\n\n.order-token {\n  margin: 0;\n  font-size: 1.143em; /* text-base - relative for font scaling */\n  font-weight: 700; /* font-bold */\n  letter-spacing: -0.025em; /* tracking-tight */\n  color: #0f172a; /* text-slate-900 */\n  line-height: 1.25;\n}\n\n.platform-tag {\n  margin-top: 4px; /* mt-1 */\n  display: flex;\n  align-items: center;\n  gap: 8px; /* gap-2 */\n}\n\n.platform-badge {\n  display: flex;\n  align-items: center;\n  gap: 8px; /* gap-2 */\n  font-size: 0.786em; /* text-[11px] - relative for font scaling */\n  color: #64748b; /* text-slate-500 */\n  font-weight: 500; /* font-medium */\n}\n\n.platform-icon {\n  width: 24px; /* w-6 */\n  height: 24px; /* h-6 */\n  object-fit: contain;\n  border-radius: 6px; /* rounded-md */\n}\n\n.platform-badge.other {\n  background-color: #f1f5f9;\n  padding: 2px 8px;\n  border-radius: 6px;\n  font-size: 0.786em;\n}\n\n/* Card Header Right Side */\n.order-header-right {\n  text-align: right;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n\n.order-time {\n  margin: 0;\n  font-size: 0.857em; /* text-xs - relative for font scaling */\n  font-weight: 600; /* font-semibold */\n  color: #94a3b8; /* text-slate-400 */\n  line-height: 1.25;\n}\n\n.kds-itemtag-div {\n  margin-top: 4px; /* mt-1 */\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.item-count {\n  margin: 0;\n  font-size: 0.786em; /* text-[11px] - relative for font scaling */\n  color: #64748b; /* text-slate-500 */\n  font-weight: 500;\n  line-height: 1.25;\n}\n\n.chevron-icon-clickable {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2px;\n  border-radius: 6px;\n  transition: background-color 0.15s ease-in-out;\n}\n\n.chevron-icon-clickable:hover {\n  background-color: #f1f5f9;\n}\n\n.kds-chevronRightIcon-item-tag {\n  width: 14px;\n  height: 14px;\n  color: #94a3b8;\n}\n\n/* === ITEMS PREVIEW === */\n.order-items-preview {\n  margin-top: 12px;\n  border-radius: calc(1rem + 4px);\n  border: 1px solid #fef3c7;\n  background-color: rgba(255, 255, 255, 0.8);\n  padding: 8px 12px;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.7);\n}\n\n.order-items-space {\n  display: flex;\n  flex-direction: column;\n  gap: 6px; /* space-y-1.5 */\n}\n\n.order-item-preview-row {\n  display: flex;\n  align-items: start;\n  justify-content: space-between;\n  gap: 8px; /* gap-2 */\n  font-size: 0.786em; /* text-[11px] - relative for font scaling */\n}\n\n.order-item-preview-name {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis; /* truncate */\n  white-space: nowrap;\n  font-weight: 500; /* font-medium */\n  color: #334155; /* text-slate-700 */\n}\n\n.order-item-preview-qty {\n  flex-shrink: 0; /* shrink-0 */\n  border-radius: 9999px; /* rounded-full */\n  background-color: #fffbeb; /* bg-amber-50 */\n  padding: 2px 8px; /* px-2 py-0.5 */\n  font-weight: 600; /* font-semibold */\n  color: #b45309; /* text-amber-700 */\n  line-height: 1;\n}\n\n/* === FOOTER BUTTONS === */\n.order-footer {\n  margin-top: 16px; /* mt-4 */\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr)); /* grid-cols-2 */\n  gap: 8px; /* gap-2 */\n}\n\n.reject-btn-left-bar {\n  display: inline-flex;\n  height: 40px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50px;\n  border: 1px solid #e2e8f0;\n  background-color: #ffffff;\n  color: #334155;\n  cursor: pointer;\n  transition: all 0.15s ease-in-out;\n  padding: 0;\n}\n\n.reject-btn-left-bar:hover:not(:disabled) {\n  background-color: #f8fafc; /* hover:bg-slate-50 */\n}\n\n.accept-btn-left-bar {\n  display: inline-flex;\n  height: 40px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50px;\n  background-color: #020617;\n  color: #ffffff;\n  cursor: pointer;\n  border: none;\n  transition: all 0.15s ease-in-out;\n  padding: 0;\n}\n\n.accept-btn-left-bar:hover:not(:disabled) {\n  background-color: #1e293b; /* hover:bg-slate-800 */\n}\n\n.reject-btn-left-bar:disabled,\n.accept-btn-left-bar:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.btn-icon {\n  width: 16px !important;\n  height: 16px !important;\n}\n\n/* === SPINNERS === */\n.spinner {\n  border: 2px solid rgba(0, 0, 0, 0.15);\n  border-top: 2px solid #0f172a;\n  border-radius: 50%;\n  width: 16px;\n  height: 16px;\n  animation: spin 0.6s linear infinite;\n}\n\n.spinner.small {\n  width: 14px;\n  height: 14px;\n}\n\n.spinner.white {\n  border: 2px solid rgba(255, 255, 255, 0.2);\n  border-top: 2px solid #ffffff;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* === NO ORDERS VIEW === */\n.no-orders-parent-container {\n  display: flex;\n  height: 160px; /* h-40 */\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border-radius: 12px; /* rounded-xl */\n  border: 1px dashed #fde68a; /* border border-dashed border-amber-200 */\n  background-color: rgba(255, 251, 235, 0.4); /* bg-amber-50/40 */\n  text-align: center;\n  color: #94a3b8; /* text-slate-400 */\n}\n\n.no-orders-icon {\n  margin-bottom: 12px; /* mb-3 */\n  height: 32px; /* h-8 */\n  width: 32px; /* w-8 */\n  opacity: 0.3; /* opacity-30 */\n}\n\n.no-orders {\n  font-size: 1em; /* text-sm - relative for font scaling */\n  font-weight: 500; /* font-medium */\n  margin: 0;\n}\n\n/* === LOADING MORE === */\n.loading-more {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 16px;\n  color: #64748b;\n  font-size: 0.929em;\n  font-weight: 500;\n}\n\n/* Pending cards stack in their own vertically scrollable queue. */\n.left-bar-kds {\n  min-width: 0;\n  min-height: 0;\n}\n\n.leftbar-header {\n  flex-shrink: 0;\n}\n\n.orders-container {\n  flex-direction: column;\n  align-items: stretch;\n  min-width: 0;\n  min-height: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  overscroll-behavior-y: contain;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: thin;\n  scrollbar-color: #d6c4a2 #fff9ed;\n}\n\n.orders-container::-webkit-scrollbar {\n  width: 8px;\n  height: auto;\n}\n\n.orders-container::-webkit-scrollbar-thumb {\n  border: 2px solid #fff9ed;\n  border-radius: 10px;\n}\n\n.orders-container > .kds-pending-card {\n  flex: 0 0 auto;\n  width: 100%;\n  box-sizing: border-box;\n  min-width: 0;\n  height: auto;\n  min-height: 0;\n  max-height: none;\n  overflow: visible;\n}\n\n.orders-container > .kds-pending-card .order-items-preview {\n  flex: 0 0 auto;\n  min-height: 0;\n  height: auto;\n  max-height: none;\n  overflow: visible;\n}\n\n.orders-container > .kds-pending-card .order-items-space,\n.orders-container > .kds-pending-card .order-item-preview-row {\n  min-width: 0;\n}\n\n.orders-container > .kds-pending-card .order-item-preview-name {\n  overflow: visible;\n  overflow-wrap: anywhere;\n  text-overflow: clip;\n  white-space: normal;\n}\n\n.orders-container > .kds-pending-card .order-item-preview-row {\n  align-items: flex-start;\n}\n\n.orders-container > .kds-pending-card .order-item-preview-wrap > .kds-item-preparation {\n  margin: 3px 0 0;\n  padding: 4px 6px;\n  font-size: calc(9px + var(--kds-font-delta, 0px));\n}\n\n.orders-container > .kds-pending-card .order-item-preview-wrap > .kds-item-preparation .kds-prep-summary {\n  gap: 3px 8px;\n}\n\n.orders-container > .no-orders-parent-container,\n.orders-container > .loading-more {\n  flex: 0 0 auto;\n  width: 100%;\n}\n\n.orders-container:focus-visible {\n  outline: 2px solid #ad5b20;\n  outline-offset: -2px;\n}\n\n.dark .orders-container {\n  scrollbar-color: #776548 #302c25;\n}\n\n@media (max-width: 700px) {\n  .left-bar-kds {\n    flex: 0 0 min(34%, 250px);\n    width: 100%;\n  }\n\n  .orders-container > .kds-pending-card {\n    flex-basis: auto;\n    width: 100%;\n  }\n}\n\n/* Orders-view disclosure rail. The header remains present in every queue state. */\n.left-bar-kds {\n  /* Fixed basis so long item names wrap instead of widening the column. */\n  flex: 0 0 clamp(280px, 26vw, 380px);\n  width: auto;\n  min-width: 0;\n  transition: flex-basis 180ms ease;\n}\n\n.leftbar-header {\n  min-height: 54px;\n}\n\n.leftbar-content {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  min-width: 0;\n  min-height: 0;\n}\n\n.leftbar-content[hidden] {\n  display: none !important;\n}\n\n.pending-order-numbers {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  gap: 7px;\n  min-height: 0;\n  margin: 0;\n  padding: 8px 5px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  list-style: none;\n}\n\n.pending-order-number,\n.pending-number-state {\n  flex: 0 0 auto;\n  padding: 7px 2px;\n  border: 1px solid #eadbbd;\n  border-radius: 7px;\n  background: #fff;\n  color: #493c24;\n  font-size: calc(12px + var(--kds-font-delta, 0px));\n  font-weight: 750;\n  text-align: center;\n  font-variant-numeric: tabular-nums;\n  overflow-wrap: anywhere;\n}\n\n.dark .pending-order-number,\n.dark .pending-number-state {\n  border-color: #625541;\n  background: #302d27;\n  color: #e8c58a;\n}\n\n.leftbar-content > .accept-all-btn {\n  align-self: flex-end;\n  flex: 0 0 auto;\n  margin: 8px 12px 0;\n}\n\n.leftbar-content > .orders-container {\n  flex: 1 1 0;\n  min-width: 0;\n}\n\n.pending-collapse-toggle {\n  display: inline-flex;\n  flex: 0 0 34px;\n  width: 34px;\n  height: 34px;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: 1px solid #e8d7b6;\n  border-radius: 9px;\n  background: #fffdf7;\n  color: #79562e;\n  cursor: pointer;\n}\n\n.pending-collapse-toggle svg {\n  display: block;\n  width: 17px;\n  height: 17px;\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 1.8;\n}\n\n.pending-collapse-toggle:hover {\n  background: #fff5df;\n}\n\n.pending-collapse-toggle:focus-visible {\n  outline: 2px solid #ad5b20;\n  outline-offset: 2px;\n}\n\n.left-bar-kds.is-collapsed {\n  flex-basis: 66px;\n}\n\n.left-bar-kds.is-collapsed .leftbar-header {\n  flex: 0 0 auto;\n  flex-direction: column;\n  justify-content: flex-start;\n  gap: 12px;\n  padding: 12px 8px;\n}\n\n.left-bar-kds.is-collapsed .leftbar-header-left {\n  flex-direction: column;\n  gap: 7px;\n}\n\n.left-bar-kds.is-collapsed .leftbar-title {\n  writing-mode: vertical-rl;\n  transform: rotate(180deg);\n  font-size: calc(11px + var(--kds-font-delta, 0px));\n  letter-spacing: .08em;\n}\n\n.left-bar-kds.is-collapsed .leftbar-count {\n  padding: 2px 6px;\n}\n\n.left-bar-kds.is-collapsed .pending-collapse-toggle {\n  flex-basis: 32px;\n  width: 32px;\n  height: 32px;\n}\n\n.dark .pending-collapse-toggle {\n  border-color: #625541;\n  background: #302d27;\n  color: #e8c58a;\n}\n\n.dark .pending-collapse-toggle:hover {\n  background: #40392d;\n}\n\n@media (max-width: 700px) {\n  .left-bar-kds {\n    flex: 0 0 min(38vw, 280px);\n    width: min(38vw, 280px);\n  }\n\n  .left-bar-kds.is-collapsed {\n    flex: 0 0 58px;\n    width: 58px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .left-bar-kds {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
